import type { RtwError } from './lib/errors.ts';

export function ErrorBox({ error, onRetry }: { error: RtwError; onRetry?: () => void }) {
  return (
    <div class="error" role="alert" data-kind={error.kind}>
      <p>{error.message}</p>
      {error.detail && (
        <details>
          <summary>Details</summary>
          <pre>{error.detail}</pre>
        </details>
      )}
      {onRetry && <button onClick={onRetry}>Try again</button>}
    </div>
  );
}

export function Progress({ loaded, total }: { loaded: number; total: number | null }) {
  return total ? <progress value={loaded} max={total} /> : <progress />;
}
